module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/backstage-module/common/venue-search-select/venue-search-select.component.scss
// module id = ./src/app/modules/backstage-module/common/venue-search-select/venue-search-select.component.scss
// module chunks = 9